// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_optionsContainer__9fiUz {
  position: absolute;
  bottom: 0rem;
  right: 0rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0.5rem; }
  .styles_optionsContainer__9fiUz > div:first-child {
    margin: 0rem 1rem; }

.styles_parentBtn__y3Kti {
  margin-bottom: 3rem;
  width: 90%; }

.styles_headerCard__LITbd {
  height: 25vh; }

.styles_tabsCard__u6D0w {
  margin-top: 1rem;
  min-height: 72vh; }

.styles_tasksCard__6marr {
  margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/roadmaps/components/screens/ViewRoadmap/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,oBAAoB,EAAA;EAPxB;IASQ,iBAAiB,EAAA;;AAKzB;EACI,mBAAmB;EACnB,UAAU,EAAA;;AAGd;EACI,YAAY,EAAA;;AAGhB;EACI,gBAAgB;EAChB,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA","sourcesContent":[".optionsContainer {\n    position: absolute;\n    bottom: 0rem;\n    right: 0rem;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 1rem 0.5rem;\n    & > div:first-child {\n        margin: 0rem 1rem;\n    }\n}\n\n\n.parentBtn {\n    margin-bottom: 3rem;\n    width: 90%;\n}\n\n.headerCard {\n    height: 25vh;\n}\n\n.tabsCard {\n    margin-top: 1rem;\n    min-height: 72vh;\n}\n\n.tasksCard {\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionsContainer": `styles_optionsContainer__9fiUz`,
	"parentBtn": `styles_parentBtn__y3Kti`,
	"headerCard": `styles_headerCard__LITbd`,
	"tabsCard": `styles_tabsCard__u6D0w`,
	"tasksCard": `styles_tasksCard__6marr`
};
export default ___CSS_LOADER_EXPORT___;
